import { React } from 'react';
import Hero from './components/Hero';
import './styles/home.scss';
import { motion } from 'framer-motion';
import Pengu from './components/Pengu'
import HeroMain from './components/hero-items/HeroMain';

const Home = () => (
        <div className="home-container">
            <Hero className="home" 
            first="/img/keyart/banner-first.jpg" 
            second ="/img/keyart/banner-second.jpg" 
            gradOne=".25turn, rgba(183,280, 255, 0) 70%, rgba(183,280, 255, 1), #E9F0AA)"
            gradTwo=".75turn, rgba(0,0,0,0) 75%, rgba(248, 240, 200, 1), #E9F0AA) "
            color = "#E9F0AA"
            contents={<HeroMain sizing/>}/>
            <div className="video-wrapper">
                <div className="video">
                    <div className="trailer-container">
                        <iframe src="https://www.youtube.com/embed/-MnE17o-U58" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            <div className="bg-container">
                <div className="diagonal">
                    <div className="header-container">
                        <h1 className="header-title">Endless Adventures Everywhere</h1>
                        <br/>
                        <p className="header-body">Two thrilling Strategy RPG classics come together in one collection, giving new and old players alike an exciting and long-lasting gaming experience that they can take on the go.</p>
                    </div>
                </div>
            </div>
            <div className="portal-container">
            <a href="https://nisamerica.com/nis-classics/" target="_blank" rel="noopener noreferrer">
                <motion.div className="sprite-container"
                    initial={{
                        translateX: '100%'
                    }}
                    animate={{
                        translateX: '0%'
                    }}
                    transition={{
                        delay: 5,
                        duration: 1
                    }}
                >
                </motion.div>
            </a>
            </div>
            <Pengu link="./products"/>

        </div>
);


export default Home;